import { type HTMLStyledProps, styled } from '@repo/panda/jsx';

export type LogoVariants = 'wordmark' | 'wordmark-pro' | 'wordmark-pro-stacked' | 'icon';

export const Logo = ({ variant = 'icon', ...props }: HTMLStyledProps<'svg'> & { variant?: LogoVariants }) => {
    switch (variant) {
        case 'wordmark-pro':
            return (
                <styled.svg
                    viewBox="0 0 928 91"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid meet"
                    {...props}
                >
                    <title>Wand logo</title>
                    <path
                        d="M638.796 0.0927734C653.797 0.0336094 665.987 12.1826 665.987 27.209V49.9189C665.987 64.7758 653.975 76.8057 639.135 76.8057H589.326V44.0869H633.158V33.3047H578.604V90.7539H545.774V27.3789C545.774 12.2419 558.017 0.0927734 573.137 0.0927734H638.796Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M900.879 0.211914C915.719 0.212043 927.731 12.2418 927.731 27.0986V50.3691C927.731 65.2257 915.71 77.2557 900.879 77.2559H834.261C819.421 77.2559 807.408 65.2258 807.408 50.3691V27.0986C807.408 12.2418 819.421 0.211914 834.261 0.211914H900.879ZM840.348 44.1377H894.673V33.3467H840.348V44.1377Z"
                        fill="currentColor"
                    />
                    <path
                        d="M381.897 50.2754C381.897 65.1323 369.885 77.1621 355.045 77.1621H305.406V33.1602H294.403V77.1621H261.574V27.7354C261.574 12.539 273.867 0.280273 288.987 0.280273H338.235V44.002H349.068V0.161133H381.897V50.2754Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M485.922 0.0078125C500.762 0.00794186 512.774 12.0378 512.774 26.8945V50.165C512.774 65.0218 500.753 77.0516 485.922 77.0518H392.451V0.0585938H485.922V0.0078125ZM425.391 43.9502H479.716V33.1602H425.391V43.9502Z"
                        fill="currentColor"
                    />
                    <path
                        d="M223.608 0.161133C238.728 0.22056 251.021 12.3605 251.021 27.5059V36.208H251.03V76.8818H218.201V33.0498H163.706V43.8408H207.538V76.9414H130.817V27.3447C130.818 12.3097 142.949 0.161133 157.95 0.161133H223.608Z"
                        fill="currentColor"
                    />
                    <path
                        d="M33.0078 43.832H43.8916V0.161133H76.7803V43.832H87.3838V0.161133H120.213V76.9326H27.7529C12.5225 76.9326 0 64.4531 0 49.1973V0.161133H32.8975L33.0078 43.832Z"
                        fill="currentColor"
                    />
                    <path
                        d="M796.847 44.1035V76.874H746.809C731.969 76.8739 719.956 64.844 719.956 49.9873V44.1035H796.847Z"
                        fill="currentColor"
                    />
                    <path
                        d="M770.054 0C784.894 0 796.906 12.0298 796.906 26.8867V33.3301H709.522V76.8232H676.583V26.8867C676.583 12.0299 688.596 0.000108793 703.436 0H770.054Z"
                        fill="currentColor"
                    />
                </styled.svg>
            );

        case 'wordmark-pro-stacked':
            return (
                <styled.svg
                    viewBox="0 0 107 38"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid meet"
                    {...props}
                >
                    <title>Wand Pro logo</title>
                    <path
                        d="M19.4023 18.2832C22.5314 18.2708 25.0742 20.8051 25.0742 23.9395V28.6768C25.074 31.7755 22.5688 34.2842 19.4736 34.2842H9.08398V27.46H18.2266V25.2109H6.84766V37.1943H0V23.9746C0.00010824 20.8174 2.55342 18.2834 5.70703 18.2832H19.4023ZM74.0703 18.3076C77.1655 18.3079 79.6709 20.8173 79.6709 23.916V28.7695C79.6709 31.8683 77.1637 34.3777 74.0703 34.3779H60.1738C57.0787 34.3777 54.5732 31.7892 54.5732 28.6904V23.916C54.5733 20.8173 57.0787 18.3079 60.1738 18.3076H74.0703ZM52.3691 27.4639V34.2988H41.9316C38.8365 34.2986 36.3311 31.7892 36.3311 28.6904V27.4639H52.3691ZM46.7812 18.2637C49.8764 18.2639 52.3818 20.7734 52.3818 23.8721V25.2158H34.1553V34.2881H27.2842V23.8721C27.2843 20.7734 29.7897 18.2639 32.8848 18.2637H46.7812ZM61.4443 27.4697H72.7754V25.2197H61.4443V27.4697ZM79.6572 10.4844C79.6572 13.5831 77.1518 16.0925 74.0566 16.0928H63.7021V6.91406H61.4072V16.0928H54.5596V5.7832C54.5596 2.61351 57.1236 0.0557559 60.2773 0.0556641H70.5498V9.17578H72.8096V0.03125H79.6572V10.4844ZM101.356 0C104.452 0.000248894 106.957 2.50964 106.957 5.6084V10.4619C106.957 13.5606 104.45 16.0701 101.356 16.0703H81.8594V0.0107422H101.356V0ZM46.6426 0.03125C49.7964 0.0436457 52.3613 2.57623 52.3613 5.73535V7.5498H52.3623V16.0342H45.5146V6.8916H34.1484V9.14258H43.291V16.0469H27.2881V5.70117C27.2882 2.56532 29.8185 0.0314266 32.9473 0.03125H46.6426ZM6.88477 9.14062H9.15527V0.03125H16.0156V9.14062H18.2266V0.03125H25.0742V16.0449H5.78906C2.61231 16.0449 0.000125898 13.4418 0 10.2598V0.03125H6.8623L6.88477 9.14062ZM88.7305 9.16504H100.062V6.91504H88.7305V9.16504Z"
                        fill="currentColor"
                    />
                </styled.svg>
            );

        case 'wordmark':
            return (
                <styled.svg
                    viewBox="0 0 725 109"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid meet"
                    {...props}
                >
                    <title>Wand logo</title>
                    <path
                        d="M683.729 -3.05176e-05H554.942V108.715H683.34C706.354 108.715 725.01 90.0591 725.01 67.0458V41.2804C725.01 18.4864 706.533 -3.05176e-05 683.729 -3.05176e-05ZM678.275 61.9804L601.498 61.9206V46.7147L678.275 46.6847V61.9804Z"
                        fill="currentColor"
                    />
                    <path
                        d="M123.522 61.6614H108.516V0H61.9805V61.6614H46.595L46.4554 0H0V69.1996C0 90.6873 17.4195 108.416 38.9173 108.416H169.978V0H123.522V61.6614Z"
                        fill="currentColor"
                    />
                    <path
                        d="M493.57 61.9406H478.285V0.199392H408.616C387.228 0.199392 369.889 17.5392 369.889 38.9272V108.715H416.304V46.6149H431.869V108.715H502.056C523.005 108.715 539.986 91.7343 539.986 70.7849V-3.05176e-05H493.57V61.9406Z"
                        fill="currentColor"
                    />
                    <path
                        d="M354.902 50.9125L354.942 108.376H308.487V46.4554H231.43V61.6614H293.39V108.416H184.915V38.4087C184.915 17.1902 202.115 -3.05176e-05 223.323 -3.05176e-05L316.194 0.109652C337.582 0.109652 354.922 17.24 354.922 38.6281L354.882 50.9125H354.902Z"
                        fill="currentColor"
                    />
                </styled.svg>
            );

        default:
            return (
                <styled.svg
                    viewBox="0 0 147 94"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid meet"
                    {...props}
                >
                    <title>Wand logo</title>
                    <path
                        d="M106.452 53.2217H93.5197V0H53.4153V53.2217H40.156L40.0357 0H0V59.7281C0 78.2749 15.0123 93.577 33.5392 93.577H146.488V0H106.452V53.2217Z"
                        fill="currentColor"
                    />
                </styled.svg>
            );
    }
};
